import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from "aws-amplify";
import { Row, Col, Card, Table, Spinner } from 'react-bootstrap';
import { CloudDownload } from 'react-bootstrap-icons';
import { parseAsMoment } from './../../../shared/utils/date'
import { downloadCsv } from './../../../shared/utils/csv'

const ExpiringLicencesCard = ({ loading, licences = [], limit = 10 }) => {
  const list = (licences || []).slice(0, limit);

  const hasData = Array.isArray(licences) && licences.length > 0;

  // ユーザ詳細ページへのリンク情報
  const goUserPage = (argUser) => ({
    pathname: `/user/${argUser}`
  });
  
  // ライセンス詳細ページへのリンク情報
  const goLicencePage = (argLicence, argUser) => ({
    pathname: `/licence/${argLicence}`,
    state: { userId: argUser },
  });

  const parseData = (arg) => {
    return parseAsMoment(arg).format('YYYY年MM月DD日')
  }

  // CSV出力ハンドラ（※全件を対象にするなら licences を使う）
  const handleExportCsv = () => {
    if (!hasData) return;

    const headers = [
      'ユーザID',
      'ユーザ名',
      'ライセンスID',
      '保守期限',
      '残り日数',
    ];

    const rows = licences.map((row) => [
      row.userId || '',
      row.username || '',
      row.licenceKey || '',
      row.maintenanceDate ? parseData(row.maintenanceDate) : '',
      typeof row.remainingDays === 'number' ? row.remainingDays : '',
    ]);

    downloadCsv('expiring_licences.csv', headers, rows);
  };

  return (
    <Card>
      <Card.Header>
        <Row>
          <Col sm={12} md={8}>
            期限間近ライセンス（保守期限ベース／30日以内／最新 {limit} 件）
          </Col>
          <Col sm={12} md={4} className="d-flex align-items-center justify-content-end">
            {/* <CloudDownload style={{cursor: 'pointer'}} color="gray" size={16} onClick={handleExportCsv} disabled={loading || !hasData} /> */}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="p-2">
        {loading ? (
          <div className="text-center py-3">
            <Spinner
              as="span"
              animation="border"
              role="status"
              aria-hidden="true"
            />
          </div>
        ) : (
          <Table size="sm" hover responsive className="text-nowrap">
            <thead>
              <tr>
                <th>ユーザ名</th>
                <th>ライセンスID</th>
                <th>保守期限</th>
                <th>残り日数</th>
              </tr>
            </thead>
            <tbody>
              {!hasData ? (
                <tr>
                  <td colSpan={4} className="text-muted text-center">
                    データがありません
                  </td>
                </tr>
              ) : (
                list.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <Link 
                        to={goUserPage(row.userId)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {row.username}
                      </Link>{' '}
                    </td>
                    <td>
                      <Link 
                        to={goLicencePage(row.id, row.userId)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                          {row.licenceKey}
                      </Link>{' '}
                    </td>
                    <td>
                      {row.maintenanceDate ? parseData(row.maintenanceDate) : ''}
                    </td>
                    <td className="text-end">{row.remainingDays}日{' '}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default ExpiringLicencesCard;
